import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { flex } from "shared/theme/mixins";

export const StyledContainer = styled(Box)`
  ${flex({ jc: "center", ai: "center" })}
  gap: 0.25rem;
  align-self: stretch;
  margin: 0 -6px;
`;

export const StyledRectangleContainer = styled(Box)`
  ${flex({ fd: "column", ai: "flex-start" })};
  gap: 2px;
  padding: 2px 3px;
  width: 33px;
  height: 20px;
  border-radius: 2px;
  background-color: #95cde7;
`;

export const StyledBigRectangleContainer = styled(StyledRectangleContainer)`
  width: 50px;
  height: 30px;
  padding: 3px 5px;
  gap: 3px;
  border-radius: 3px;
`;

export const StyledRectangleChildContainer = styled(Box, {
  shouldForwardProp: (propName) => !["bgColor"].includes(propName),
})<{
  bgColor: string;
}>`
  border-radius: 9999px;
  background-color: ${({ bgColor }) => bgColor};
`;
